import Splide from '@splidejs/splide'
import "@splidejs/splide/css/core"

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	bannerElements && new Splide('.js-banner-slider', {
		type: 'loop',
		arrows: false,
		pagination: true,
		keyboard: false,
		drag: false,
		rewind: true,
		autoplay: true,
		speed: 1000,
		interval: 5000,
		pauseOnHover: false,
		snap: true,
		autoHeight: true,
		classes: {
			pagination: 'splide__pagination js-banner-slider-controls'
		},
	}).mount()

	// --- USP Slider ---
	const uspElements = document.querySelector('.js-usp-slider')
	uspElements && new Splide('.js-usp-slider', {
		type: 'loop',
		autoplay: true,
		perPage: 1,
		perMove: 1,
		pagination: false,
		gap: 20,
		arrows: false,
		mediaQuery: 'min',
		breakpoints: {
			767: {
				perPage: 2,
			},
			1023: {
				perPage: 3,
			},
			1439: {
				perPage: 4,
			},
		},
	}).mount()

	// --- Logos Slider ---
	const logosElements = document.querySelector('.js-logo-slider')
	logosElements && new Splide('.js-logo-slider', {
		type: 'loop',
		perPage: 1,
		perMove: 1,
		gap: 20,
		pagination: false,
		arrows: false,
		mediaQuery: 'min',
		autoplay: true,
		speed: 1000,
		interval: 5000,
		breakpoints: {
			450: {
				perPage: 2,
			},
			767: {
				perPage: 3,
				gap: 40,
			},
			1023: {
				perPage: 4,
			},
			1279: {
				perPage: 6,
			},
		},
	}).mount()

	// --- Product Feed Sliders ---
	const productFeed = document.querySelectorAll('.js-product-slider')
	for (let i = 0; i < productFeed.length; i++) {
		new Splide(productFeed[i], {
			type: 'slide',
			perPage: 2,
			perMove: 1,
			gap: "20px",
			pagination: true,
			arrows: false,
			mediaQuery: 'min',
			autoplay: false,
			breakpoints: {
				767: {
					perPage: 2,
				},
				1023: {
					perPage: 3,
				},
				1279: {
					perPage: 5,
				},
			},
			classes: {
				pagination: 'splide__pagination js-product-slider-controls'
			},
		}).mount()
	}

	// --- Brands Sliders ---
	const brands = document.querySelectorAll('.js-brands-slider')
	for (let i = 0; i < brands.length; i++) {
		new Splide(brands[i], {
			type: 'loop',
			perPage: 2,
			perMove: 1,
			gap: 20,
			pagination: true,
			arrows: false,
			mediaQuery: 'min',
			autoplay: true,
			breakpoints: {
				767: {
					perPage: 3,
				},
				1023: {
					perPage: 4,
				},
				1279: {
					perPage: 6,
				},
			},
			classes: {
				pagination: 'splide__pagination js-brands-slider-controls'
			},
		}).mount()
	}
}
